module.exports = "<span (click)=\"deleteSku()\" title=\"Delete SKU\" class=\"icon-trash\"\n    style=\"cursor:pointer;\"></span>\n\n"